module.exports = __webpack_public_path__ + "media/images/p-projectOverviews/graph-9c0774b70649f91b47b7c1cb8ded3d2a.svg";